export default {
      path: '/social-challenge',
      component: () => import('./SocialChallenge'),
      meta: {
        title: '心动挑战',
        expireIn: 'Sun Jan 02 2099 16:51:32 GMT+0800 (China Standard Time)',
        designWidth: 750
      }
    }
